/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable sonarjs/no-duplicate-string */

import React, { Component } from 'react';
import FeedSettingsRows from './FeedSettingRows';

class FeedSettings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      feedStatusDropdownState: null,
      feedStatusState: null,
      invalidateOddsStatusState: null,
      invalidateOddsDropdown: null,
      feedPusherSettings: [],
      previousFeedStatusState: null,
      previousInvaldateOddsStatusState: null,
    };
  }

  componentDidMount() {
    this.props.getFeedSettings();
  }

  componentDidUpdate() {
    if (this.state.feedPusherSettings.length === 0 && this.props.feedSettings.length !== 0) {
      this.setState({
        feedPusherSettings: this.props.feedSettings,
      });
    }
  }

  componentWillUnmount() {
    this.props.clearFeedSettings();
  }

  togglefeedStatusDropdownState = (id) => {
    if (id === this.state.feedStatusDropdownState) {
      this.setState({
        feedStatusDropdownState: null,
      });
    } else {
      this.setState({
        feedStatusDropdownState: id,
      });
    }
  };

  toggleInvalidateOddsDropdown = (id) => {
    if (id === this.state.invalidateOddsDropdown) {
      this.setState({
        invalidateOddsDropdown: null,
      });
    } else {
      this.setState({
        invalidateOddsDropdown: id,
      });
    }
  };

  toggleFeedStatusState = (id) => {
    const currentFeedStatusState = this.state.feedPusherSettings.find((l) => l.leagueId === id).feedStatus;
    this.setState({
      feedStatusState: id,
      feedStatusDropdownState: null,
      previousFeedStatusState: currentFeedStatusState,
    });
  };

  toggleInvalidateOddsStatusState = (id) => {
    const currentOddsState = this.state.feedPusherSettings.find((l) => l.leagueId === id).invalidateOdds;
    this.setState({
      invalidateOddsStatusState: id,
      invalidateOddsDropdown: null,
      previousInvaldateOddsStatusState: currentOddsState,
    });
  };

  handleFeedStatusChange = (leagueId, newFeedState) => {
    const currentFeedPusherState = this.state.feedPusherSettings.map((l) => ({ ...l }));
    const leagueIndex = this.state.feedPusherSettings.findIndex((l) => l.leagueId === leagueId);
    currentFeedPusherState[leagueIndex].feedStatus = newFeedState;

    this.setState({
      feedPusherSettings: currentFeedPusherState,
      feedStatusDropdownState: null,
    });
  };

  handleInvalidateOddsChange = (leagueId, newOddsState) => {
    const currentFeedPusherState = this.state.feedPusherSettings.map((l) => ({ ...l }));
    const leagueIndex = this.state.feedPusherSettings.findIndex((l) => l.leagueId === leagueId);
    currentFeedPusherState[leagueIndex].invalidateOdds = newOddsState;

    this.setState({
      feedPusherSettings: currentFeedPusherState,
      invalidateOddsDropdown: null,
    });
  };

  closeConfirmationBtns = () => {
    const currentFeedPusherState = this.state.feedPusherSettings.map((l) => ({ ...l }));
    if (this.state.feedStatusState) {
      const leagueIndex = this.state.feedPusherSettings.findIndex((l) => l.leagueId === this.state.feedStatusState);
      currentFeedPusherState[leagueIndex].feedStatus = this.state.previousFeedStatusState;
      this.setState({
        feedStatusState: null,
        feedStatusDropdownState: null,
        feedPusherSettings: currentFeedPusherState,
        previousFeedStatusState: null,
      });
    } else if (this.state.invalidateOddsStatusState) {
      const leagueIndex = this.state.feedPusherSettings.findIndex((l) => l.leagueId === this.state.invalidateOddsStatusState);
      currentFeedPusherState[leagueIndex].invalidateOdds = this.state.previousInvaldateOddsStatusState;
      this.setState({
        invalidateOddsStatusState: null,
        invalidateOddsDropdown: null,
        feedPusherSettings: currentFeedPusherState,
        previousInvaldateOddsStatusState: null,
      });
    }
  };

  requestForUpdate = () => {
    if (this.state.feedStatusState) {
      const newFeedStatusState = this.state.feedPusherSettings.find((l) => l.leagueId
        === this.state.feedStatusState).feedStatus;
      this.props.updateFeedStatus({
        leagueId: this.state.feedStatusState,
        feedStatus: newFeedStatusState,
      });
    } else if (this.state.invalidateOddsStatusState) {
      const newOddsState = this.state.feedPusherSettings.find((l) => l.leagueId
        === this.state.invalidateOddsStatusState).invalidateOdds;
      this.props.updateOddsStatus({
        leagueId: this.state.invalidateOddsStatusState,
        invalidateOdds: newOddsState,
      });
    }

    this.setState({
      feedStatusDropdownState: null,
      feedStatusState: null,
      invalidateOddsStatusState: null,
      invalidateOddsDropdown: null,
      previousFeedStatusState: null,
      previousInvaldateOddsStatusState: null,
    });
  };

  render() {
    return (
      <div className="table-wrapper m-t-30">
        <div className="table-holder">
          <table className="table-style table-style--setting">
            <thead>
              <tr>
                <th>League</th>
                <th>Feed Status</th>
                <th>Invalidate Odds</th>
                <th />
              </tr>
            </thead>
            <tbody>
              <FeedSettingsRows
                feedPusherSettings={this.state.feedPusherSettings}
                feedStatusState={this.state.feedStatusState}
                invalidateOddsStatusState={this.state.invalidateOddsStatusState}
                feedStatusDropdownState={this.state.feedStatusDropdownState}
                togglefeedStatusDropdownState={this.togglefeedStatusDropdownState}
                handleFeedStatusChange={this.handleFeedStatusChange}
                invalidateOddsDropdown={this.state.invalidateOddsDropdown}
                toggleFeedStatusState={this.toggleFeedStatusState}
                toggleInvalidateOddsDropdown={this.toggleInvalidateOddsDropdown}
                handleInvalidateOddsChange={this.handleInvalidateOddsChange}
                requestForUpdate={this.requestForUpdate}
                closeConfirmationBtns={this.closeConfirmationBtns}
                toggleInvalidateOddsStatusState={this.toggleInvalidateOddsStatusState}
                permissionToUpdate={this.props.permissionToUpdate}
                leagues={this.props.leagues}
                permissionToInvalidateOdds={this.props.permissionToInvalidateOdds}
              />

            </tbody>
          </table>
        </div>

      </div>
    );
  }
}

export default FeedSettings;

